import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FieldConfigurationPipe } from './field-configuration.pipe';
import { IsFieldActivePipe } from './is-field-active.pipe';
import { IsFieldRequiredPipe } from './is-field-required.pipe';
import { ShouldShowSectionPipe } from './should-show-section.pipe';

@NgModule({
  declarations: [ShouldShowSectionPipe, FieldConfigurationPipe, IsFieldRequiredPipe, IsFieldActivePipe],
  imports: [CommonModule],
  exports: [ShouldShowSectionPipe, FieldConfigurationPipe, IsFieldRequiredPipe, IsFieldActivePipe],
})
export class TurnoverConfigurationPipesModule {}
